import FlexiText from "slotworks/graphics/elements/flexi-text";
import Layers from "slotworks/graphics/layers/layers";
import { Services } from "slotworks/services/services";

export default class BetBarValueText {

    protected currencyValueText: FlexiText;
    private creditsValueText: FlexiText;
    private valueText: FlexiText;

    constructor(private layer: Layers, private name: string, protected hideNillValue = false) {

    }

    public refresh() {
        this.currencyValueText = this.layer.getFlexiText(this.name + "_currency_value");
        this.creditsValueText = this.layer.getFlexiText(this.name + "_credits_value");
        this.valueText = this.layer.getFlexiText(this.name + "_value");
    }

    public update(value: number) {
        if (this.currencyValueText) {
            if (value <= 0 && this.hideNillValue) {
                this.currencyValueText.setText("");
            } else {
                this.currencyValueText.setText(Services.currency.format(value, true, false));
            }
        }

        if (this.creditsValueText) {
            if (value <= 0 && this.hideNillValue) {
                this.creditsValueText.setText("");
            } else {
                this.creditsValueText.setText(Services.currency.format(value, true, true));
            }
        }

        if (this.valueText) {
            if (value <= 0 && this.hideNillValue) {
                this.valueText.setText("");
            } else {
                this.valueText.setText(Services.currency.format(value));
            }
        }
    }
}
